var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "v-slider" },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isMinScroll,
                expression: "!isMinScroll",
              },
            ],
            staticClass: "v-slider__scroll_button",
            on: { click: () => _vm.scroll("left", 1) },
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/icons/arrow-down.svg"),
                alt: "<",
              },
            }),
          ]
        ),
      ]),
      _c(
        "div",
        {
          ref: "scroller",
          staticClass: "v-slider__scroller",
          on: { scroll: _vm.onScroll },
        },
        [_vm._t("default")],
        2
      ),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isMaxScroll,
                expression: "!isMaxScroll",
              },
            ],
            staticClass: "v-slider__scroll_button",
            on: { click: () => _vm.scroll("right", 1) },
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/icons/arrow-down.svg"),
                alt: ">",
              },
            }),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }